module.exports = __webpack_public_path__ + "img/example7-4.e0ab3dd1.png";